export class StringUtils {
	static capitalize(text: string): string {
		if (!text) return text;
		return text.charAt(0).toUpperCase() + text.slice(1);
	}
}
